module.exports = __webpack_public_path__ + "static/img/yszy6.52ca085.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/yszy6.png
// module id = NACT
// module chunks = 1